import { validateResponse } from "../../response.js";
import { acceptJson } from "../../shared.js";
import { placePredictionsExtendedResponseSpec } from "./specs.js";
const getPlacePredictionsExtended = async (apiUrl, request) => {
  return validateResponse(
    placePredictionsExtendedResponseSpec,
    await fetch(`${apiUrl}/place/predictions/extended?name=${request.place}`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
export {
  getPlacePredictionsExtended
};
//# sourceMappingURL=place-predictions-extended.js.map
